import { useCallback } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { Icon } from '@/components/atoms/Icon/Icon';

interface CopyTextProps {
  className?: string;
  value?: string;
  onCopy?: () => void;
}

export const CopyText = ({ className, value, onCopy }: CopyTextProps) => {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value || '');
    onCopy?.();
  }, []);

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: sp[8],
        border: '1px solid #d9d9d9',
        background: '#faf7f3',
        color: '#404042',
        borderRadius: '4px',
      }}
    >
      <Box
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          p: sp[8],
          pr: 0,
        }}
      >
        {value}
      </Box>
      <Box
        component='button'
        onClick={handleCopy}
        sx={{ all: 'unset', cursor: 'pointer', p: sp[8], pl: 0 }}
      >
        <Icon icon='copy' />
      </Box>
    </Box>
  );
};

CopyText.displayName = 'CopyText';

export default CopyText;
